import React from 'react'
import Ad from '../../../assets/svgs/Ad.svg'
import HeartBubble from '../../../assets/images/icons/HeartBubble.png'
import Envelope from '../../../assets/images/icons/Envelope.png'
import CallRecording from '../../../assets/images/icons/CallRecording.png'
import PersonStar from '../../../assets/images/icons/PersonStar.png'
import SimpleStrokeCard from '../../cards/SimpleStrokeCard'

const DigitalMarketing = () => {
    const cardData = [
        {
            header: 'Digital Advertising Suite',
            text: 'Optimize your ad spend intelligently across Search, Social, Display, and Video.',
            link: '/products/digital-advertising',
            icon: Ad
        },
        {
            header: 'Social Management Suite',
            text: 'Tailor content with precision, from local engagement to global campaigns.',
            link: '/products/social-management',
            icon: HeartBubble
        },
        {
            header: 'Call Recording & Tracking',
            text: 'Link marketing campaigns directly to customer call responses, refining strategies with each insight.',
            link: '/products/call-tracking',
            icon: CallRecording
        },
        {
            header: 'SMS & Email Marketing',
            text: 'Execute direct and personalized marketing campaigns effortlessly.',
            link: '/products/sms-tracking',
            icon: Envelope
        },
        {
            header: 'Reputation Management',
            text: 'Integrate review management into your marketing strategy to strengthen your brand presence and stay competitive.',
            link: '/products/reputation-management',
            icon: PersonStar
        }
    ]

    return (
        <section className='py-20 px-8 sm:px-[58px] md:px-[68px] lg:px-[90px] xl:px-32'>
            <div className='flex flex-col gap-14 lg:gap-24'>
                <div className='text-center'>
                    <p className='headerText2 mb-4 lg:mb-5'>Redefining Your Marketing Solution</p>
                    <p className='bodyText2'>Forget the slow-paced, costly tactics of the past. Eulerity accelerates your marketing efforts into the future with advanced marketing automation, AI-driven insights, and seamless execution. Our comprehensive suite streamlines your processes, enhances creative execution, and optimizes media buying — all executed with unparalleled transparency and uniformity.</p>
                </div>
                <div className='grid grid-cols-1 gap-24 lg:grid-cols-2 lg:gap-y-24 lg:gap-x-8'>
                    {
                        cardData.map((card, idx) => {
                            return (
                                <SimpleStrokeCard
                                    cardHeader={card.header}
                                    cardText={card.text}
                                    cardIcon={card.icon}
                                    cardLink={card.link}
                                    key={idx}
                                    useIconBg
                                />
                            )
                        })
                    }
                </div>
            </div>
        </section>
    )
}

export default DigitalMarketing